import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { ContentService } from '@23degrees/shared/services/content';

import { GlobalService } from '@23degrees/shared/services/global/global.service';
import { AuthQuery } from '@23degrees/stores/auth/auth.query';
import { isOwner, realContent } from '@23degrees/utilities/content.utils';
import { NotificationsService } from 'angular2-notifications';
/**
 * Rules access for the whole plattform this
 * is the place to check if user has access to
 * a page in general
 */
@Injectable({
  providedIn: 'root',
})
export class FoldersGuard {
  private router = inject(Router);
  private authQuery = inject(AuthQuery);
  private globalService = inject(GlobalService);
  private contentService = inject(ContentService);
  private notificationService = inject(NotificationsService);

  private isServer = this.globalService.isServer();
  private folderPages = ['collections', 'folders', 'shared', 'recent', 'trash', 'favorites'];
  private folderTypes = ['collection', 'folder'];

  public canActivate = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> => {
    const { root } = route.params;
    const slug = route.params['folder-1'];

    if (slug && slug !== 'root') {
      const content = await this.resolveShortcut(slug);

      // check if content is deleted
      if (!content || content.deleted_at) {
        if (content && isOwner(content, this.authQuery.user())) {
          this.router.navigate(['/trash']);
          return false;
        }

        this.router.navigate(['/folders']);
        this.notificationService.error('Not found', 'The request folder has not been found!');
        return false;
      }

      // Check if content is not collection/folder
      if (!this.folderTypes.includes(content.type)) {
        this.router.navigate(['/view', slug]);
        return false;
      }
    }

    return true;
  };

  private async resolveShortcut(slug) {
    let content;
    try {
      //content = await this.contentManager.getContentBySlug(slug, this.isServer, false);
      content = await this.contentService.getContentBySlugPromise(slug);
      return realContent(content);
    } catch (e) {}
    return content;
  }

  public canActivateChild = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {};
}
